import React from 'react';
import { Auth as SupabaseAuth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from '../lib/supabase';
import { Logo } from '../components/Logo';
import { useUser } from '../contexts/UserContext';

function Auth() {
  const { error } = useUser();

  // Helper function to format error messages
  const getErrorMessage = (error: string | null) => {
    if (!error) return null;
    
    if (error.includes('deleted')) {
      return error;
    }

    if (error.includes('user_already_exists') || error.includes('User already registered')) {
      return 'This email is associated with a deleted account. Please contact support to restore access.';
    }

    return error;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-100 to-purple-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-block p-3 bg-white rounded-full shadow-md mb-4">
            <Logo className="h-8 w-8 text-indigo-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Welcome to SoundLink</h1>
          <p className="text-gray-600 mt-2">Sign in to connect with music lovers</p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6">
          {error && (
            <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-red-600 text-sm">{getErrorMessage(error)}</p>
            </div>
          )}

          <SupabaseAuth
            supabaseClient={supabase}
            appearance={{
              theme: ThemeSupa,
              variables: {
                default: {
                  colors: {
                    brand: '#4F46E5',
                    brandAccent: '#4338CA',
                  },
                },
              },
              className: {
                container: 'w-full',
                button: 'w-full px-4 py-2 rounded-lg font-medium',
                input: 'w-full px-4 py-2 rounded-lg border border-gray-300',
                label: 'text-sm font-medium text-gray-700',
              },
            }}
            providers={[]}
            localization={{
              variables: {
                sign_up: {
                  email_label: 'Email address',
                  password_label: 'Create a password',
                  button_label: 'Create account',
                  loading_button_label: 'Creating account...',
                },
                sign_in: {
                  email_label: 'Email address',
                  password_label: 'Your password',
                  button_label: 'Sign in',
                  loading_button_label: 'Signing in...',
                },
              },
            }}
          />
        </div>

        <p className="text-center text-sm text-gray-600 mt-6">
          By signing up, you agree to our Terms of Service and Privacy Policy
        </p>
      </div>
    </div>
  );
}

export default Auth;